import React from "react"
import Arabic from "../components/arabic"
import Card from "../components/card"

const PagiOne = ({ number }) => {
  return (
    <Card
      number={number}
      title="Membaca Ayat Kursi"
      arabic={() => (
        <Arabic>
          اللَّهُ لاَ إِلَهَ إِلاَّ هُوَ الْحَيُّ الْقَيُّومُ، لاَ تَأْخُذُهُ
          سِنَةٌ وَلاَ نَوْمٌ، لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ،
          مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلاَّ بِإِذْنِهِ، يَعْلَمُ مَا
          بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ، وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ
          عِلْمِهِ إِلاَّ بِمَا شَاءَ، وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ
          وَالْأَرْضَ، وَلَا يَئُودُهُ حِفْظُهُمَا، وَهُوَ الْعَلِيُّ الْعَظِيمُ
        </Arabic>
      )}
      indonesian={() => (
        <p>
          “Allah, tidak ada ilah (yang berhak disembah) melainkan Dia, yang
          hidup kekal lagi terus menerus mengurus (makhluk-Nya). Dia tidak
          mengantuk dan tidak tidur. Kepunyaan-Nya apa yang di langit dan di
          bumi. Tiada yang dapat memberi syafa’at di sisi-Nya tanpa seizin-Nya.
          Dia mengetahui apa-apa yang di hadapan mereka dan di belakang mereka.
          Mereka tidak mengetahui apa-apa dari ilmu Allah melainkan apa yang
          dikehendaki-Nya. Kursi Allah meliputi langit dan bumi. Dia tidak
          merasa berat memelihara keduanya. Dan Dia Maha Tinggi lagi Maha
          besar.” (QS. Al Baqarah: 255)
        </p>
      )}
      info={() => (
        <p>
          Siapa yang membacanya ketika petang, maka ia akan dilindungi (oleh
          Allah dari berbagai gangguan) hingga pagi. Siapa yang membacanya
          ketika pagi, maka ia akan dilindungi hingga petang.
        </p>
      )}
      source={() => (
        <p>
          HR. Al Hakim (1: 562). Syaikh Al Albani menshahihkan hadits tersebut
          dalam Shahih At Targhib wa At Tarhib no. 655.
        </p>
      )}
    />
  )
}

export default PagiOne
